<div class="flex flex-col h-full gap-medpace" [class.card]="isNewWindow()">
    <div class="flex flex-row gap-medpace items-start">
        <!-- items-start is needed - if formerrors appear on date-range-picker, it will not destroy the design -->
        <mds-date-range-picker
            [startFormCtrl]="filterFormGroup.controls.startDatepickerControl"
            [endFormCtrl]="filterFormGroup.controls.endDatepickerControl"
            [appearance]="'outline'"
            [label]="'Visit Date'"
            (dateInput)="datePickerDateChanged()"
        />
        <div class="w-full">
            <!-- empty placeholder for mds-date-range-picker's label of 20px -->
            <!-- this is used to align vertically the Reset and Export Data buttons with mds-date-range-picker's date input -->
            <div class="h-[20px]"></div>
            <div class="flex flex-row justify-between">
                <mds-button
                    class="reset-btn"
                    [id]="'reset-filter-btn'"
                    [variant]="'tonal'"
                    [color]="'warn'"
                    [label]="'Reset'"
                    (clickEvent)="resetFilters()"
                />
                <mds-button
                    [id]="'export-set-btn'"
                    [variant]="'tonal'"
                    [color]="'primary'"
                    [label]="'Export data'"
                    (clickEvent)="onBtExport()"
                />
            </div>
        </div>
    </div>
    @if (this.gridApi()) {
        <mds-divider />
        <div class="flex gap-medpace items-center min-h-[3.2rem]">
            <span>Quick filter:</span>
            <mds-button-toggle-group
                [formCtrl]="formControlToggleButtons"
                [multiple]="true"
                [buttons]="buttonsToggle"
                [required]="false"
                [disabled]="false"
                [deselectable]="false"
                (buttonGroupChangeEvent)="quickFilterChangeEvent($event)"
            />
        </div>
    }

    <mds-ag-grid
        class="flex-1"
        [tableHeight]="isNewWindow() ? '100%' : tableHeight()"
        [gridOptions]="gridOptions"
        [data]="gridData()"
        [style.border-collapse]="'collapse'"
        [columnDefs]="colDefs()"
        [defaultColDef]="defaultColDef"
        (gridReady)="onGridReady($event)"
        (filterChanged)="onFilterChanged()"
        (sortChanged)="onColumnChanged()"
        (columnMoved)="onColumnChanged()"
        (columnResized)="onColumnChanged()"
        (columnPinned)="onColumnChanged()"
        (columnVisible)="onColumnChanged()"
    />
</div>
